// ** React Imports
import React, { ReactNode, useContext } from 'react'

// ** Next Imports
import Link from 'next/link'
import { useRouter } from 'next/router'

// ** Mui Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { useMediaQuery, useTheme, SxProps, Theme } from '@mui/material'

// ** Modules Imports
import { useIntl } from 'react-intl'

// ** Source code Imports
import { useSettings } from 'src/@core/hooks/useSettings'
import apiEndpoints from 'src/configs/api'
import { Logotype } from 'src/layouts/components/icons'
import { HistoryContext } from 'src/context/HistoryContext'

interface IProps {
  sx?: SxProps<Theme> | undefined
  title?: string
  children: ReactNode
}

const DocsLayout = ({ sx, title, children }: IProps) => {
  const { formatMessage } = useIntl()

  const router = useRouter()
  const history = useContext(HistoryContext)

  const theme = useTheme()
  const smallMatch = useMediaQuery(theme.breakpoints.down('sm'))

  const { settings } = useSettings()
  const { mode } = settings

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Box sx={{ position: 'relative' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box
            sx={{
              width: 120,
              display: 'flex',
              justifyContent: 'flex-start'
            }}
          >
            <Link href={apiEndpoints.landingUrl}>
              <Logotype sx={{ px: 2 }} height={32} mode={mode} />
            </Link>
          </Box>
          {!smallMatch && (
            <Box>
              <Typography
                title={title}
                variant='h5'
                component='div'
                sx={{
                  width: 1,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textAlign: 'center'
                }}
              >
                {title}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              width: 120,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            {history.length > 1 ? (
              <Button sx={{ ml: 2 }} onClick={() => router.back()} color='inherit'>
                {formatMessage({ id: 'back' })}
              </Button>
            ) : (
              <Button sx={{ ml: 2 }} onClick={() => router.push('/')} color='inherit'>
                {formatMessage({ id: 'go-home' })}
              </Button>
            )}
          </Box>
        </Toolbar>
      </Box>
      <Box
        sx={{
          width: 1,
          py: 2,
          ...sx
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default DocsLayout
